import {S3ConnectionActions, S3ConnectionActionTypes} from "../actions/s3ConnectionActions";

export const initialS3ConnectionState: S3ConnectionState = {
  isLoading: false,
}

export interface S3ConnectionState {
  isLoading: boolean;
}

export default function s3ConnectionReducer(state: S3ConnectionState = initialS3ConnectionState, action: S3ConnectionActions): S3ConnectionState {
  switch (action.type) {
    case S3ConnectionActionTypes.TEST_S3_CONNECTION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case S3ConnectionActionTypes.TEST_S3_CONNECTION_SUCCESS:
    case S3ConnectionActionTypes.TEST_S3_CONNECTION_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
}
